import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { KeyValuePair } from '../../models/key-value-pair';
import { CaseService } from '../../services/case/case.service';
import { StickyNoteService } from '../../services/sticky-note/sticky-note.service';
import { StringSizes } from '../form/constants/constants';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCard } from '@angular/material/card';
import { TextareaComponent } from '../form/textarea/textarea.component';
import { AutocompleteComponent } from '../form/autocomplete/autocomplete.component';
import { MatButton } from '@angular/material/button';
import { BusyButtonDirective } from '../../directives/busy-button.directive';
import { DialogContentFocusableDirective } from '../../directives/dialog-content-focusable.directive';

@Component({
  selector: 'app-create-sticky-note-modal',
  templateUrl: './create-sticky-note-modal.component.html',
  styleUrls: ['./create-sticky-note-modal.component.scss'],
  imports: [
    MatDialogTitle,
    CdkDrag,
    CdkDragHandle,
    CdkScrollable,
    MatDialogContent,
    DialogContentFocusableDirective,
    FormsModule,
    ReactiveFormsModule,
    MatCard,
    TextareaComponent,
    AutocompleteComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    BusyButtonDirective,
  ],
})
export class CreateStickyNoteModalComponent implements OnInit, OnDestroy {
  stickyNoteForm: UntypedFormGroup;
  stringSizes = StringSizes;
  activeCall = false;

  learnerOptions: KeyValuePair[] = [];
  private subscriptions: Subscription[] = [];

  get note() {
    return this.stickyNoteForm.get('note') as UntypedFormControl;
  }

  get caseId() {
    return this.stickyNoteForm.get('caseId') as UntypedFormControl;
  }

  get isFamily() {
    return this.authService.isPortalUser;
  }

  constructor(
    private dialogRef: MatDialogRef<any>,
    private snackBar: MatSnackBar,
    private stickyNoteService: StickyNoteService,
    private caseService: CaseService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.stickyNoteForm = new UntypedFormGroup({
      caseId: new UntypedFormControl(''),
      note: new UntypedFormControl('', Validators.required),
    });

    this.caseService.getCaseList().subscribe((cases) => {
      this.learnerOptions = cases.map((x) => new KeyValuePair(x.id, x.learnerFullName));
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    });
  }

  close() {
    this.dialogRef.close();
  }

  onSave() {
    if (this.note.value) {
      this.activeCall = true;
      this.stickyNoteService.createNote(this.note.value, this.caseId.value).subscribe(
        () => {
          this.stickyNoteCreated();
        },
        (err) =>
          this.snackBar.open('Failed to Create Sticky Note', 'Close', {
            duration: 3000,
          }),
        () => this.close()
      );
    }
  }

  onSaveAndAdd() {
    if (this.note.value) {
      this.activeCall = true;
      this.stickyNoteService.createNote(this.note.value, this.caseId.value).subscribe(() => {
        this.stickyNoteCreated();
      });
    }
  }

  stickyNoteCreated() {
    this.stickyNoteForm.reset();
    this.activeCall = false;
    this.snackBar.open('Sticky Note Created!', 'Close', {
      duration: 3000,
    });
  }
}
